import { render } from "./KeyEnt.vue?vue&type=template&id=da2b7420"
import script from "./KeyEnt.vue?vue&type=script&lang=ts"
export * from "./KeyEnt.vue?vue&type=script&lang=ts"
script.render = render

export default script